export default __webpack_public_path__ + "static/media/event4.3b9f5b6a.jpg";